<div class="pr-3 py-4 pl-4 h-full w-full flex flex-col" (window:resize)="onResize()" #pageSample1>
  <div #pageBreadcrumb>
    <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
  </div>
  <div class="flex justify-between" #pageOptionBtnGroup>
    <div class="mt-3 mb-6 text-2xl font-medium">Sample 1</div>
    <div class="flex mt-3 mb-6">
      <button class="mr-3" nz-button nzType="primary" (click)="showPopup()">
        <span>Popup</span>
      </button>
      <button class="mr-3" nz-button nzType="primary" (click)="openDrawer()">Drawer</button>
      <nz-upload nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        [nzHeaders]="{ authorization: 'authorization-text' }" (nzChange)="handleChange($event)">
        <button nz-button class="mr-3">Import</button>
      </nz-upload>
      <nz-upload nzAction="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        [nzHeaders]="{ authorization: 'authorization-text' }" (nzChange)="handleChange($event)">
        <button nz-button class="mr-3">Export</button>
      </nz-upload>
    </div>
  </div>
  <div #pageSearch>
    <div class="flex mt-3 mb-6">
      <nz-input-group class="mr-3" [nzSuffix]="suffixIconSearch">
        <input type="text" nz-input placeholder="Tìm kiếm" />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <i nz-icon nzType="search"></i>
      </ng-template>
      <button class="mr-3" nz-button nzType="primary">Tìm kiếm</button>
      <button class="mr-3" nz-button nzType="default">Elastic Search</button>
      <button nz-button nzType="text" *ngIf="isOpen === false" (click)="onclickOpen()">Mở rộng<i nz-icon nzType="down"
          nzTheme="outline"></i></button>
      <button nz-button nzType="text" *ngIf="isOpen === true" (click)="onclickOpen()">Đóng<i nz-icon nzType="up"
          nzTheme="outline"></i></button>
    </div>
  </div>
  <div *ngIf="isOpen" #pageExpandedSearch>
    <div class="flex mb-6">
      <nz-select class="mr-3" ngModel="lucy" nzAllowClear nzPlaceHolder="Choose">
        <nz-option nzValue="lucy" nzLabel="Lucy"></nz-option>
      </nz-select>
      <nz-select class="mr-3" nzAllowClear nzPlaceHolder="Select OS">
        <nz-option nzLabel="Windows" nzValue="windows"></nz-option>
        <nz-option nzLabel="Apple" nzValue="apple"></nz-option>
        <nz-option nzLabel="Android" nzValue="android"></nz-option>
      </nz-select>
      <nz-select class="mr-3" ngModel="lucy" nzAllowClear nzPlaceHolder="Choose">
        <nz-option nzValue="lucy" nzLabel="Lucy"></nz-option>
      </nz-select>
    </div>
  </div>
  <div class="relative">
    <nz-table #hi nzOuterBordered [nzData]="listOfData" nzSize="middle" [nzScroll]="{ y: height + 'px',x: width +'px' }"
      class="absolute">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" [nzSortFn]="sortNameFn" nzLeft>STT</th>
          <th nzWidth="100px" nzLeft>Mã</th>
          <th nzWidth="200px" nzLeft>Họ đệm</th>
          <th nzWidth="100px" nzLeft >Tên</th>
          <th nzWidth="100px">Giới tính</th>
          <th nzWidth="200px">Ngày sinh</th>
          <th >Dân tộc</th>
          <th>Tuổi</th>
          <th [nzFilters]="listOfEmployeeFilter" [nzFilterFn]="filterEmloyeeFn">Đã đi làm</th>
          <th nzLeft>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of hi.data">
          <td nzLeft>{{ data.numberIndex }}</td>
          <td nzLeft>{{ data.code }}</td>
          <td nzLeft>{{ data.firstName }}</td>
          <td nzLeft>{{ data.lastName }}</td>
          <td>{{ data.gender }}</td>
          <td>{{ data.dob }}</td>
          <td>{{ data.folk }}</td>
          <td>{{ data.age }}</td>
          <td><label nz-checkbox nzDisabled [ngModel]="data.employee"></label></td>
          <td nzLeft>
            <nz-space>
              <nz-space-item>
                <a nz-popconfirm nzPopconfirmTitle="Sure to delete?" (click)="showPopup()"><i nz-icon nzType="edit"
                nzTheme="outline"></i></a>
              </nz-space-item>
              <nz-space-item>
                <a nz-popconfirm nzPopconfirmTitle="Sure to delete?" (nzOnConfirm)="deleteRow()"><i nz-icon nzType="delete"
                nzTheme="outline"></i></a>
              </nz-space-item>
            </nz-space>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
